import { handleActions } from 'redux-actions';
import { IDLE } from 'settings/constants/apiState';
import { cloneDeep, get } from 'lodash-es';

import {
  requestGetSymphonyPreferencesAction,
  requestGetSymphonyStatsAction,
  requestResetSymphonySearchAction,
  requestUpdateColumnsAction,
  requestUpdateSymphonySearchAction,
  requestUpdateSymphonyShowActiveAction,
} from 'store/actions/symphony';
import { appLogoutAction } from 'store/actions/app';
import { parsePreference, SymphonyColumns } from 'pages/Symphony/components/Columns/helpers';

const initialData = {
  state: IDLE,
  data: null,
  meta: {},
  columns: SymphonyColumns,
  search: '',
  showActive: true,
};

export default handleActions(
  {
    [requestUpdateColumnsAction]: (state, { payload }) => {
      return {
        ...state,
        columns: payload,
      };
    },
    [requestUpdateSymphonyShowActiveAction]: (state, { payload }) => {
      return {
        ...state,
        showActive: payload?.showActive,
      };
    },
    [requestUpdateSymphonySearchAction]: (state, { payload }) => {
      return {
        ...state,
        search: payload?.search,
      };
    },
    [requestResetSymphonySearchAction]: (state) => {
      return {
        ...state,
        search: '',
      };
    },
    [requestGetSymphonyPreferencesAction]: (state, { payload }) => {
      return {
        ...state,
        columns: payload?.data ? parsePreference(payload?.data) : state.columns,
      };
    },
    [requestGetSymphonyStatsAction]: (state, { payload }) => ({
      ...state,
      state: payload.state,
      data: get(payload, 'data', initialData.data) || state.data,
      meta: get(payload, 'meta', initialData.meta),
    }),
    [appLogoutAction]: () => cloneDeep(initialData),
  },
  initialData,
);
